import React from 'react'
import { ContentsTable, SectionTitle, TopWave } from '../../../components'
import { worldWaritems } from '.'

export const SecondWar = () => {
	return (
		<div className='homeCard'>
			<TopWave />
			<SectionTitle title='Segunda Guerra Mundial' />
			<ContentsTable items={worldWaritems} />

			<div
				className='subjectCard mb-5 ownShadow'
				data-aos='fade-up'
				data-aos-duration='700'
				data-aos-once='true'
			>
				<p>
					{' '}
					La Segunda Guerra Mundial fue el segundo conflicto bélico de carácter
					internacional, el cual transcurrió entre los años <b>1939</b> y{' '}
					<b>1945</b>. Esto involucró, directa o indirectamente, a buena parte
					de las potencias económicas y militares y a países tercermundistas.
					Los cuales se aliaron en dos bandos: Los Aliados (conformado
					principalmente por Francia, el Reino Unido, Estados Unidos, China, la
					Unión Soviética y Polonia) y las Potencias del Eje (conformado por
					Alemania, el Imperio Japonés e Italia).
				</p>
				<hr />
				<h4>Antedecentes</h4>
				<ul>
					<li>
						<b>El tratado de Versalles:</b> Dicho tratado estableció como
						principal responsable de las consecuencias de la Primera Guerra
						Mundial a Alemania, por tal motivo, se le fue impuesto una
						indemnización descomunal, se le prohibió rehacer su ejército y se le
						fue arrebatado el control de sus colonias africanas. Todo lo
						mencionado anteriormente dejó a Alemania en una profunda crisis
						económica y social interna, pues la población se sentía sumamente
						descontenta y humillada por la situación.
					</li>
					<li>
						<b>Surgimiento del facismo:</b> Personajes como Adolfo Hitler y
						Benito Mussolini se aprovecharon del descontento general hacia las
						democracias (y de la crisis económica que azotó a Alemania durante
						el año 1929) para instaurar sistemas totalitarios, que se
						caracterizaban por la militarización de los sectores sociales y por
						profesar un sentimiento nacionalista radical, que consiguiera
						recuperar la gloria del Imperio Alemán.
					</li>
					<li>
						<b>Enfrentamiento bélicos previos tales como:</b> La Guerra Civil
						Española (1936-1939), en la cual intervinieron Alemania, Italia y la
						Unión soviética, apoyando respectivamente al bando nacionalista y al
						republicano y la continuación de la Guerra Sino-Japonesa.
					</li>
					<li>
						<b>Invasión de Alemania a Polonia:</b> En 1939, Alemania y la Unión
						Soviética firmaron un tratado de No Agresión (Pacto
						Ribbentrop-Mólotov), en el cual se repartieron ciertos territorios
						de Europa y establecieron formar alianzas en contra del otro, sin
						embargo, Alemania incumplió este tratado al invadir Polonia. Por
						ello, la Unión Soviética y resto de potencias Europeas le declararon
						la guerra a Alemania.
					</li>
				</ul>
				<hr />
				<h4>Desarrollo de la guerra</h4>
				<p>
					El desarrollo de la Segunda Guerra Mundial se puede dividir en tres
					etapas:
				</p>
				<ul>
					<li>
						<b>La guerra relámpago (1939-1941):</b> Comprendió las invasiones
						hechas por Alemania al territorio Europeo incluyendo Francia. Su
						nombre se debe a la eficacia de la estrategia ofensiva de las tropas
						alemanas.
					</li>
					<li>
						<b>La guerra total (1941-1943):</b> En dicha etapa, la guerra se
						globalizó, pues se dieron sucesos como la invasión alemana a la URSS
						y el ataque a la base militar estadounidense Pearl Harbour, que
						provocaron que se incorporarán la Unión Soviética y los Estados
						Unidos al conflicto.
					</li>
					<li>
						<b>La derrota del Eje (1944-1945):</b> Italia fue la primera en
						sucumbir, posteriormente Alemania, luego de oponer una tenaz
						resistencia, y Japón sólo declaró su rendición hasta después de que
						las bombas atómicas destruyeran los territorios de Hiroshima y
						Nagasaki.
					</li>
				</ul>
				<br />
				<p>
					<b>Puntos clave</b>
				</p>
				<ul>
					<li>
						<b>La batalla de Stalingrado:</b> Fue un enfrentamiento que se dio
						entre las tropas soviéticas (el ejército Rojo) y alemanas por el
						control de Stalingrado. En esta, los Alemanes se rindieron ante la
						URSS.
					</li>
					<li>
						<b>Operación Overlord:</b> El 6 de junio de 1944, más de 156.000
						soldados, en su mayoría estadounidenses, británicos y canadienses,
						desembarcaron en las playas de Normandía. Sin esperar la llegada de
						los Aliados, París se levanta y es liberada el 25 de agosto.
					</li>
					<li></li>
				</ul>
				<hr />
				<h4>Consecuencias</h4>
				<ul>
					<li>
						<b>Consecuencias sociales:</b> En estas se encuentran la pérdida de
						vidas humanas, aproximadamente 50 millones de personas murieron,
						entre estas victimas del holocausto Nazi (eliminación sistemática
						principalemente de judíos, discapacitados, homosexuales, opositores
						de la ideología Nazi, etc) y de los bombardeos a Hiroshima y
						Nagasaki (además de los daños en infraestructura y campos por los
						bombardeos).
						<br /> <br />
						Con el objetivo principal de mantener la paz internacional se creó
						la ONU. También el papel de la mujer iría adquiriendo mayor
						relevancia, debido a su participación en ciertas actividades
						consideradas masculinas (la mayoría de hombres se encontraban
						luchando en la guerra).
					</li>
					<li>
						<b>Consecuencias políticas:</b> La Segunda Guerra Mundial trajo
						consigo una división ideológica (comunismo vs Capitalismo) que
						dividió al globo en dos hemisferios ideológicos, liderados por la
						Unión Soviética y EE. UU.
						<br />
						<br />
						El territorio Alemán (Berlín) fue dividida en dos partes: la
						occidental administrada por los Estados Unidos y la orientan
						administrada por la Unión Soviética. En 1961, se construyó el Muro
						de Berlín, el cual dividió a este durante 28 años.
					</li>
					<li>
						<b>Consecuencias económicas:</b> debido a la destrucción de
						infraestructura, plantas productoras y campos de diferentes países
						de Europa y de Japón y China, hubo un declive en la economía, el
						cual produjo pobreza y hambruna. Por otro lado, el sistema
						capitalista estadounidense se fortaleció.
					</li>
				</ul>
				<br />
				<hr />
				<h5>Bibliografía</h5>
				<ul>
					<li>
						Enciclopedia del Holocausto. (7 de junio de 2019). La segunda guerra
						mundial en Europa. https://encyclopedia.ushmm.org
						<br />
						/content/es/article/world-war-ii-in-europe
					</li>
					<li>
						Editorial Etecé. Concepto Historia (21 de mayo de 2024). Segunda
						Guerra Mundial https://concepto.de/segunda-guerra-mundial/
					</li>
				</ul>
			</div>
		</div>
	)
}
